import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet, View } from 'react-native';
import { theme } from '@xbto/design-system';
import { useBreakpoints } from '../../hooks';
export const NavWidth = 200;
export default function ComponentWeb({ noLeftCol = false, leftContent, rightContent, }) {
    const { breakpoints } = useBreakpoints();
    return (_jsxs(View, { style: $.container, children: [!noLeftCol && (_jsx(View, { style: [
                    $.leftCol,
                    breakpoints.LESS_THAN_M ? $.leftColPhone : $.leftColDesktop,
                    // keep zIndex to keep the leftCol zindex from being overriden by the reset class
                    breakpoints.MORE_THAN_M && { zIndex: 10 },
                ], children: leftContent })), _jsx(View, { style: [
                    $.rightCol,
                    breakpoints.LESS_THAN_M ? $.rightColPhone : $.rightColDesktop,
                    noLeftCol && $.rightColFull,
                ], children: rightContent })] }));
}
const $ = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
        flexDirection: 'row',
        height: '100%',
    },
    leftCol: {
        backgroundColor: theme.color.background.white,
    },
    leftColPhone: {
        width: 0,
    },
    leftColDesktop: Object.assign(Object.assign({}, StyleSheet.absoluteFillObject), { 
        // @ts-expect-error web only
        position: 'fixed', width: NavWidth, height: '100vh', boxSizing: 'border-box', borderRightWidth: 1, borderRightColor: theme.color.border.primary }),
    rightCol: {
        backgroundColor: theme.color.background.white,
    },
    rightColPhone: {
        flexGrow: 1,
        maxWidth: '100%',
    },
    rightColDesktop: {
        marginLeft: NavWidth,
        width: 'calc(100% - 200px)',
    },
    rightColFull: {
        marginLeft: 0,
    },
});
